import React, {FC} from 'react'
import {useEffectOnce} from 'react-use'
import {inject, observer} from 'mobx-react'
import {RouteComponentProps} from 'react-router-dom'
import classnames from 'classnames'
import {Row, Col, Checkbox} from 'antd'

import {UserStoreProps} from '@/stores/user'
import '@/styles/page/Renewal.less'
import SelectForm from "@/components/Select/SelectForm";
import PayMethods from "@/components/service/PayMethod";
import Bottom from "@/components/service/Bottom";
import report from '@/utils/log'


const Renewal: FC<RouteComponentProps & UserStoreProps> = inject('UserStore')(observer(props => {
  const prefixCls = 'renewal'
  const {RenewalStore} = props.UserStore
  const {productIds, prices, changePriceId, payType, togglePayType, totalPrice, deviceBuy, priceId} = RenewalStore

  useEffectOnce(()=> {
    // 续费页面加载成功 事件上报
    report({
      eventId: 'E1500',
      pageId: 'P15',
      ext: '',
    })
    // 初始化数据
    RenewalStore.initProductIds()
    // 获取设备价格列表
    RenewalStore.getDevicePrices()
  })

  return (
    <>
      <Row gutter={[0, 16]} className={classnames(prefixCls)}>
        <Col>
          <div className={classnames(prefixCls + '_title')}>云手机续费</div>
        </Col>
        <Col>
          <Row gutter={[10, 10]} className={classnames(prefixCls + '_device_list')}>
            <Col>
              <div className={classnames(prefixCls + '_device_list_title')}>云手机续费</div>
            </Col>
            <Col>
              <Row type={'flex'} gutter={[10, 16]}>
                {
                  productIds.map(key => {
                    return (
                      <Col key={key}>
                        <Checkbox disabled={true} value={key} checked={true}>{key}</Checkbox>
                      </Col>
                    )
                  })
                }
              </Row>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row align='middle' gutter={[12, 20]}>
            <Col>
              <SelectForm
                title='套餐名称'
                dataSource={prices}
                value='id'
                lable='title'
                onChange={changePriceId}
                selectValue={priceId}
              ></SelectForm>
            </Col>
            <Col>
              <PayMethods className={classnames('buy_methods')} payType={payType} togglePayType={togglePayType}></PayMethods>
            </Col>
          </Row>
        </Col>
      </Row>
      <Bottom totalPrice={totalPrice} deviceBuy={deviceBuy}></Bottom>
    </>
  )
}))

export default Renewal
